/**
 * 掲示板 対応内容（アクション時のレポート）の hook。
 * 仕様書: docs/02_work/done/plan_board_feature.md §7-7
 *
 * `board_posts/{postId}/action_reports/{uid}` を読む。
 * 機密を含まないので Firestore 直読み（rules の isInternal で保護）。
 * 書込は actOnBoardPost (Callable) のみ。
 */
import type { BoardActionReport, BoardActionReportView } from '@goenhub/shared';
import { BOARD_COLLECTIONS } from '@goenhub/shared';
import { useQuery } from '@tanstack/react-query';
import { collection, getDocs } from 'firebase/firestore';

import { db } from '@/lib/firebase';
import { toDate } from '@/lib/firestoreTime';

export function useBoardActionReports(postId: string | undefined) {
  return useQuery({
    queryKey: ['board_action_reports', postId],
    enabled: Boolean(postId),
    queryFn: async (): Promise<BoardActionReportView[]> => {
      const snap = await getDocs(
        collection(db, BOARD_COLLECTIONS.posts, postId!, BOARD_COLLECTIONS.actionReports),
      );
      return snap.docs.map((d) => {
        const r = d.data() as BoardActionReport;
        return {
          uid: d.id,
          url: r.url ?? null,
          bodyHtml: r.bodyHtml ?? '',
          uploaderName: r.uploaderName ?? d.id,
          state: r.state,
          updatedAt: toDate(r.updatedAt)?.toISOString() ?? null,
        };
      });
    },
  });
}
